module.exports = __webpack_public_path__ + "static/media/bg-banner-mobile.053b7830.png";